// extracted by mini-css-extract-plugin
export default {"task-container":"style_task-container__C38Gi","task-title":"style_task-title__7SiDr"};